import React from 'react';

interface SuccessStepProps {
  onReturnToApp: () => void;
}

const SuccessStep: React.FC<SuccessStepProps> = () => {
  return (
    <div className="max-w-2xl mx-auto text-center">
      {/* Success Animation */}
      <div className="mb-8">
        <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-12 h-12 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Account Created Successfully! 🎉
        </h2>
        
        <p className="text-lg text-gray-600 mb-8">
          Your driver verification has been submitted and your account is now active
        </p>
      </div>

      {/* Information Cards */}
      <div className="grid md:grid-cols-2 gap-6 mb-8">
        <div className="bg-blue-50 rounded-lg p-6 border border-blue-200">
          <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>
          <h3 className="font-semibold text-blue-800 mb-2">Verification Status</h3>
          <p className="text-blue-700 text-sm">
            Your application is under review. We'll notify you once verified.
          </p>
        </div>

        <div className="bg-green-50 rounded-lg p-6 border border-green-200">
          <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h3 className="font-semibold text-green-800 mb-2">Login Credentials</h3>
          <p className="text-green-700 text-sm">
            Use your phone number and password to login to the X Ryde driver app
          </p>
        </div>
      </div>

      {/* Next Steps */}
      <div className="bg-gray-50 rounded-lg p-6 border border-gray-200 mb-8">
        <h3 className="font-semibold text-gray-800 mb-4">What's Next?</h3>
        <div className="space-y-3 text-left">
          <div className="flex items-start">
            <span className="w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm mr-3 flex-shrink-0">1</span>
            <p className="text-gray-700 text-sm">Our team will review your documents within 24-48 hours</p>
          </div>
          <div className="flex items-start">
            <span className="w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm mr-3 flex-shrink-0">2</span>
            <p className="text-gray-700 text-sm">You'll receive a notification when your account is approved</p>
          </div>
          <div className="flex items-start">
            <span className="w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm mr-3 flex-shrink-0">3</span>
            <p className="text-gray-700 text-sm">Start accepting rides and earning with X Ryde!</p>
          </div>
        </div>
      </div>

      <p className="text-gray-500 text-sm mt-4">
        Tap the checkmark icon ↑ above to login to X Ryde
      </p>
    </div>
  );
};

export default SuccessStep;